import { render, staticRenderFns } from "./DobField.vue?vue&type=template&id=001a3e38&"
import script from "./DobField.vue?vue&type=script&lang=js&"
export * from "./DobField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports